<template>
  <AnalyticsTemplate 
    page-title="桥梁禁航统计"
    chart-type="forbid"
  />
</template>

<script>
import AnalyticsTemplate from './AnalyticsTemplate.vue'

export default {
  name: 'ForbidAnalytics',
  components: {
    AnalyticsTemplate
  }
}
</script>
